import directives from './module';
import {HttpSvcFactory} from '../services/HttpSvc';
import {AuthenticationSvc} from '../services/AuthenticationSvc';
import {Utils} from 'underscore-extensions';
import {Strings} from '../Strings';

class LoginCtrl {
    login = {
        '@class': 'basic',
        email: undefined as string | undefined,
        password: undefined as string | undefined
    };

    readonly requiredFields = ['email', 'password'];
    readonly redirectMsg = this.$sce.trustAsHtml(this.AuthenticationSvc.loginRedirectMessage);
    readonly isRedirectMsgVisible = this.AuthenticationSvc.loginRedirect;

    loading = false;
    invalidLogin = false;
    unknownError = false;

    constructor(private $sce: ng.ISCEService,
                private $stateParams: ng.ui.IStateParamsService,
                private AuthenticationSvc: AuthenticationSvc,
                private HttpSvc: HttpSvcFactory) {
    }

    loginSubmit(): void {
        this.invalidLogin = false;
        this.unknownError = false;
        if (!this.correctForm()) return;

        this.loading = true;
        this.HttpSvc('authenticate')
            .post(this.login, {headers: options.user.hash ? options.headers : {}})
            .then(r => r.data).then((response: ApiError | anm.SecureUser) => {
            if (Utils.isApiError(response)) {
                this.invalidLogin = true;
                return null;
            } else {
                const {redirectUrl} = this.$stateParams;
                if (redirectUrl) {
                    this.AuthenticationSvc.loginRedirect = redirectUrl;
                }
                return this.AuthenticationSvc.login(response);
            }
        }).catch(() => this.unknownError = true).finally(() => this.loading = false);
    }

    hideModal = () => this.AuthenticationSvc.loginModalShown = false;

    openSignUp() {
        this.hideModal();
        this.AuthenticationSvc.openSignUpPage(null, {email: this.login.email}, {reload: true});
    }

    correctForm() {
        return _.every(this.requiredFields, field =>
            _.isString(this.login[field]) && this.login[field].length > 0);
    }

}

directives.component('login', {
    controller: LoginCtrl,
    templateUrl: require('modals/login.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/Login.ts